// src/components/TweaksPanel.jsx
// In-app theming + density controls. Persists via useTweaks (localStorage).
import React, { useState } from 'react';
import Icon from '../shared/components/Icon';

export default function TweaksPanel({ tweaks, setTweak }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="tweaks-fab"
        onClick={() => setOpen(o => !o)}
        aria-label="Open tweaks"
      >
        <Icon name="sparkle" size={16} stroke={2} />
      </button>
      {open && (
        <aside className="tweaks-panel" role="dialog" aria-label="Tweaks">
          <header className="tweaks-head">
            <h3>Tweaks</h3>
            <button className="icon-btn" onClick={() => setOpen(false)} aria-label="Close"><Icon name="x" size={14} /></button>
          </header>

          <div className="tweaks-body">
            <Section label="Theme">
              <Row label="Accent">
                <div className="swatch-row">
                  {['#4f46e5', '#0ea5e9', '#0d9488', '#d97706', '#7c3aed', '#db2777'].map(c => (
                    <button
                      key={c}
                      className={`swatch ${tweaks.accent === c ? 'on' : ''}`}
                      style={{ background: c }}
                      onClick={() => setTweak('accent', c)}
                      aria-label={`Set accent ${c}`}
                    />
                  ))}
                </div>
              </Row>
              <Row label="Dark mode">
                <Toggle on={tweaks.dark} onChange={v => setTweak('dark', v)} />
              </Row>
            </Section>

            <Section label="Layout">
              <Row label="Density">
                <div className="seg">
                  {['compact', 'regular', 'comfy'].map(d => (
                    <button key={d} className={tweaks.density === d ? 'on' : ''} onClick={() => setTweak('density', d)}>
                      {d}
                    </button>
                  ))}
                </div>
              </Row>
              <Row label="Show heatmap">
                <Toggle on={tweaks.showHeatmap} onChange={v => setTweak('showHeatmap', v)} />
              </Row>
            </Section>
          </div>
        </aside>
      )}
    </>
  );
}

function Section({ label, children }) {
  return (
    <div className="tweak-section">
      <div className="tweak-section-label">{label}</div>
      {children}
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div className="tweak-row">
      <span className="tweak-row-label">{label}</span>
      {children}
    </div>
  );
}

function Toggle({ on, onChange }) {
  return (
    <button className={`toggle ${on ? 'on' : ''}`} onClick={() => onChange(!on)} role="switch" aria-checked={on}>
      <span className="toggle-thumb" />
    </button>
  );
}
